import {
  initialState,
  Actions,
  State,
  GET_RELATED_POSTS,
  GET_RELATED_POSTS_SUCCESS,
  GET_RELATED_POSTS_ERROR,
  RESET_GET_RELATED_POSTS,
} from "../../types/post/get-related-posts";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_RELATED_POSTS:
      return {
        ...state,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_RELATED_POSTS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_RELATED_POSTS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_GET_RELATED_POSTS:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
